<template>
    <div>
        <question :text="$t(item.text)" />
        <v-select
            appendToBody
            :placeholder="$t('INTERACTION_BASE_UI_DROPDOWN_SELECT_YEAR')"
            :clearable="false"
            :options="options"
            @option:selected="handleSelect"
        />
    </div>
</template>
<script>
import question from '@/components/ui/question'

export default {
    name: 'dropdownTextCountryItem',
    components: {
        question,
    },
    props: {
        item: {
            type: Object
        }
    },
    computed: {
        options() {
            const minLimit = this.item.scaleMin
            const maxLimit = this.item.scale
            const numOfYears = maxLimit - minLimit

            return [...Array(numOfYears)].map((_, i) => {
                const year = maxLimit - i
                return {
                    label: year,
                    value: year
                }
            })
        }
    },
    methods: {
        handleSelect(option) {
            this.$emit('answer', {
                result: 1,
                data: [
                {
                    key: 'TEXT',
                    value: option.value.toString()
                }
                ]
            });
        },
    },
}
</script>
<style lang="scss">

</style>
